import mutations from "./mutations";
import * as actions from "./actions";
import * as getters from "./getters";
import Cookies from 'js-cookie'

// state
let state = {
	user: null,
	modal: null,
	hasCurlProfile: null,
	token: Cookies.get('token')
}

export default {mutations, actions, state, getters}


// WEBPACK FOOTER //
// ./src/store/modules/auth/index.js